module.exports = __webpack_public_path__ + "img/DSC04023.c67f65a2.jpg";